export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/brochure_design.39fec48.svg";